import { Controller } from "@hotwired/stimulus"
import { BarController, BarElement, CategoryScale, Chart, LinearScale, Tooltip } from "chart.js"

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip)

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    percent: Number,
    color: String
  }

  connect() {
    const percent = Math.min(Math.max(this.percentValue || 0, 0), 100)

    this.chart = new Chart(this.canvasTarget, {
      type: "bar",
      data: {
        labels: [""],
        datasets: [
          {
            data: [percent],
            backgroundColor: this.colorValue || "#226597",
            borderSkipped: false,
            borderRadius: { topLeft: 29.296, bottomLeft: 29.296, topRight: 0, bottomRight: 0 },
            barThickness: 14,
            maxBarThickness: 14,
            categoryPercentage: 1,
            barPercentage: 1,
            clip: false
          },
          {
            data: [100 - percent],
            backgroundColor: "#ECECEC",
            borderSkipped: false,
            borderRadius: { topLeft: 0, bottomLeft: 0, topRight: 29.296, bottomRight: 29.296 },
            barThickness: 14,
            maxBarThickness: 14,
            categoryPercentage: 1,
            barPercentage: 1,
            clip: false
          }
        ]
      },
      options: {
        animation: false,
        events: [],
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 3, bottom: 3 }
        },
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false }
        },
        scales: {
          x: {
            stacked: true,
            min: 0,
            max: 100,
            display: false,
            grid: { display: false },
            border: { display: false }
          },
          y: {
            stacked: true,
            offset: false,
            display: false,
            grid: { display: false },
            border: { display: false }
          }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
